import { render, staticRenderFns } from "./CardStyle3.vue?vue&type=template&id=30be6f4b"
import script from "./CardStyle3.vue?vue&type=script&lang=js"
export * from "./CardStyle3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports